/**
 * Created by Askat on 2/14/2017.
 */
export * from './collateral-type-list';
export * from './collateral-type-create';
export * from './collateral-type-update';
export * from './collateral-type-details';
